export var Env;
(function (Env) {
    Env["daily"] = "daily";
    Env["pre"] = "pre";
    Env["prod"] = "prod";
})(Env || (Env = {}));
export const preUrl = 'https://pre-xl-web.cainiao.com';
export const prodUrl = 'https://xl-web.cainiao.com';
export const dailyUrl = 'https://xl-web.cainiao.test';
export const workOrderUrlMap = {
    daily: 'https://ssc.cainiao.test/c',
    pre: 'https://pre-ssc.cainiao.com/c',
    prod: 'https://ssc.cainiao.com/c',
};
export const accountTypeSearchMap = {
    cbc: 'loginType=CBC',
    cainiao: 'loginType=CN_MEMBER',
    mozi: 'loginType=MOZI',
    buc: 'loginType=MOZI',
};
export const RecordAppKey = 'NMKudtBe';
export const nonstandardFileImgLink = 'https://img.alicdn.com/imgextra/i2/O1CN01wXhCB11dpZvIkLWMF_!!6000000003785-2-tps-128-128.png';
export const CBC_ENV_DOMAIN_MAP = {
    pre: 'https://pre-h.cainiao-inc.com/help',
    prod: 'https://h.cainiao-inc.com/help',
};
export const CN_ENV_DOMAIN_MAP = {
    pre: 'https://page-pre.cainiao.com/cn-ei-cto/m-help/index.html',
    prod: 'https://page.cainiao.com/cn-ei-cto/m-help/index.html',
};
export const DOMAIN_MAP = {
    cbc: CBC_ENV_DOMAIN_MAP,
    cainiao: CN_ENV_DOMAIN_MAP,
};
export const MONITOR_KEY = 'cn-intelli-assistant-monitor-route-key';
export const REFRESH_ALL_KEY = Symbol('refresh');
